export default __webpack_public_path__ + "static/media/glassPattern.1afb4a01.png";